// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__33oQt","label":"SetPasswdForm_label__lk9Lm"};